<ap-previous-button (click)="previousQuestion()"></ap-previous-button>

<form id="optionsForm" [formGroup]="optionsForm" class="ap-margin-bottom-0 ap-margin-top-4">
    @for (option of options; track $index) {
        <ap-checkbox
            id="{{ option }}Option"
            [ariaDescribedby]="option | optionPipe | apContent"
            [label]="option | optionPipe | apContent"
            formControlName="{{ option }}"
            (click)="select()"
        >
        </ap-checkbox>
    }
    <hr />
    <ap-checkbox
        id="noObligationsOption"
        label="{{ 'noObligations' | optionPipe | apContent }}"
        formControlName="noObligations"
        (click)="noObligations()"
    >
    </ap-checkbox>

    @if (showError()) {
        <ap-notification status="error">
            {{ 'general.error.options.required' | apContent }}
        </ap-notification>
    }
    <next-button (click)="nextQuestion()"></next-button>
</form>
